import React from "react";
import BuyCart from "../../../styles/img/buy-cart.png";
import AddtofavouritesIcon from "../../../styles/img/add-to-favourites.png";
import AddedtofavouritesIcon from "../../../styles/img/added-to-favourites.png";

const UiShopActivityCard = React.memo(( props ) => {
    const {img,isFavourite,title,content,onClick} = props; 
    return (
        <>
        <div className="sb-activity-card-wr">
         <div className="sb-activity-card">
                <div className="sb-activity-card__img">
                    <img src={img} /> 
                </div>
                <div className="sb-activity-card__heading">
                    <h4>{title}</h4>
                    <span>
                        {isFavourite ? (
                                <>
                                    <img src={AddtofavouritesIcon} />
                                    
                                </>
                                ) : (
                                    <>
                                        <img src={AddtofavouritesIcon} />
                                    </>
                                )}
                    </span>
                </div>
                <p>
                    {content}
                    <span onClick={onClick}> ...more</span>
                </p>
            </div>
            </div>
        </>
    )

})

export default UiShopActivityCard;

// function UiShopActivityCard(props) {
//     const {img, isFavourite,title,content,onClick} = props; 
//     return (
//         <>
//             <div className="sb-activity-card">
//                 <div className="sb-activity-card__img">
//                     <img src={img} />
//                     <div className="sb-activity-card__add-to-favourites">
//                         {isFavourite ? (
//                             <>
//                                 <img src={AddtofavouritesIcon} />
//                                 <h5>
//                                     Add to
//                                     <br /> favourites
//                                 </h5>
//                             </>
//                         ) : (
//                             <>
//                                 <img src={AddtofavouritesIcon} />
//                                 <h5>
//                                     Added to
//                                     <br /> favourites
//                                 </h5>
//                             </>
//                         )}
//                     </div>
                   
//                 </div>
//                 <h4>{title}</h4>
//                 <p>
//                     {content}
//                     {onClick && (
//                         <span onClick={onClick}>Read more ...</span>
//                     )}
//                 </p>
//             </div>
//         </>
//     );
// }

// export default UiShopActivityCard;
